import React from 'react';
import { Box, Typography } from '@mui/material';

export function resolveReportLogoSrc({ reportLogoData, reportLogo, baseUrl = '' }) {
  const base = baseUrl || '';
  if (reportLogoData && String(reportLogoData).trim().startsWith('data:')) {
    return String(reportLogoData).trim();
  }
  if (reportLogo && String(reportLogo).trim()) {
    const path = String(reportLogo).trim();
    return path.startsWith('/') ? `${base}${path}` : `${base}/${path}`;
  }
  // logo_con_texto.jpeg vive en client/public: lo sirve el frontend, nunca el backend
  // (baseUrl) -- por eso va sin prefijo, a diferencia del logo custom de arriba.
  return '/logo_con_texto.jpeg';
}

/**
 * Cabecera de reporte: logo y fecha en la primera fila; título debajo a ancho completo
 * (un nombre largo no pisa la fecha).
 */
function ReportPdfHeader({ reportName, reportLogoData, reportLogo, baseUrl }) {
  const logoSrc = resolveReportLogoSrc({ reportLogoData, reportLogo, baseUrl });
  const dateStr = new Date().toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <Box sx={{ mb: 3, pb: 2, borderBottom: 1, borderColor: 'divider' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          mb: 1.25,
        }}
      >
        <Box
          sx={{
            width: 200,
            height: 60,
            flex: '0 0 auto',
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
          }}
        >
          <Box
            component="img"
            data-report-logo="true"
            src={logoSrc}
            alt="Logo"
            sx={{
              maxWidth: '100%',
              maxHeight: '100%',
              width: 'auto',
              height: 'auto',
              objectFit: 'contain',
            }}
          />
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ flex: '0 0 auto', textAlign: 'right' }}>
          Generado el: {dateStr}
        </Typography>
      </Box>
      <Typography
        variant="h6"
        component="h1"
        sx={{ fontSize: '1.15rem', fontWeight: 600, lineHeight: 1.3 }}
      >
        {reportName}
      </Typography>
    </Box>
  );
}

export default ReportPdfHeader;
